import { render } from "./Chips.vue?vue&type=template&id=18dddee3"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"

import "./Chips.vue?vue&type=style&index=0&id=18dddee3&lang=css"
script.render = render

export default script